import React, { Suspense } from "react";
import { Transition } from "react-transition-group";
import { Spinner } from "components/Spinner/Spinner";
import Cross from "../../assets/Icon_Modal_Cross.png";
import ErrorBoundary from "components/ErrorBoundary";
import ErrorFallback from "components/fallbacks/ErrorFallback";
import { closeRightPanel } from "reducers/rightPanel";
import { useDispatch } from "react-redux";

export interface RightPanelGenericProps {
  rightPanelContent: boolean | null;
  title?: string | null;
}

const RightPanelGeneric: React.FC<RightPanelGenericProps> = ({
  children,
  rightPanelContent,
  title = "Right panel",
}) => {
  const dispatch = useDispatch();
  const handleClosePanel = () => {
    dispatch(closeRightPanel());
  };

  return (
    <Transition
      in={!!rightPanelContent}
      timeout={100}
      mountOnEnter
      unmountOnExit
    >
      {transitionState => (
        <>
          <div
            className={"RightPanelUnderlay " + transitionState}
            onMouseDown={handleClosePanel}
          />
          <div className={"RightPanel RightPanelGeneric " + transitionState}>
            <div className="Inner">
              <div className="Top">
                <h2 className="Title">{title}</h2>
                <div className="Cross">
                  <img src={Cross} alt="Cross" onClick={handleClosePanel} />
                </div>
              </div>
              <Suspense fallback={<Spinner positionAbsolute />}>
                <ErrorBoundary fallback={<ErrorFallback />}>
                  {children ?? null}
                </ErrorBoundary>
              </Suspense>
            </div>
          </div>
        </>
      )}
    </Transition>
  );
};

export { RightPanelGeneric };
